import path from 'node:path';
import { randomUUID } from 'node:crypto';
import { componentGenerator } from '@wix/gena';
import { toJsonString } from '@wix/cli-fs';
import { getSitePluginsDir, SITE_PLUGINS_DIR } from '@wix/cli-app-definitions';
import type {
  SitePluginConfig,
  SitePluginPlacementConfig,
} from '@wix/cli-app-definitions';

const SITE_PLUGIN_TEMPLATE = path.resolve(
  __dirname,
  '../templates/site-plugin'
);

export async function generateSitePlugin(
  projectFolder: string,
  placements: SitePluginPlacementConfig[],
  folder: string,
  name: string,
  widgetName: string,
  widgetDocsLink?: string
) {
  const readablePath = path.join(SITE_PLUGINS_DIR, folder);
  const cwd = path.join(getSitePluginsDir(projectFolder), folder);
  const defaultLogoPath = path.join(
    projectFolder,
    'src/assets',
    folder,
    'logo.svg'
  );
  const sitePluginConfig: SitePluginConfig = {
    $schema: 'https://dev.wix.com/wix-cli/schemas/site-plugin.json',
    id: randomUUID(),
    referenceComponentId: randomUUID(),
    marketData: {
      name,
      logoUrl: path.relative(cwd, defaultLogoPath),
    },
    placements,
    installation: {
      autoAddToSite: true,
    },
  };

  const sitePluginConfigJSON = toJsonString(sitePluginConfig, {
    spaces: 2,
  });

  return await componentGenerator({
    template: SITE_PLUGIN_TEMPLATE,
    projectFolder,
    cwd,
    assetsOutputPath: path.join('src/assets', folder),
    data: {
      sitePluginConfigJSON,
      readablePath,
      name,
      widgetName,
      widgetDocsLink,
    },
  });
}
